/**
 * Created by mongoose on 15/09/16.
 */
import moment from "moment";
import constants from "../../utils/constants";

export const getCalendarKey = day => {
  return day == null ? null : moment(day).format("YYYY-MM-DD"); // eslint-disable-line
};

const valueType = idx => {
  switch (idx) {
    case 0:
      return "rate";
    case 1:
      return "availability";
    case 2:
      return "closed";
    case 3:
      return "minStay";
    case 4:
      return "maxStay";
    case 5:
      return "minNotice";
    case 6:
      return "maxNotice";
    default:
      return null;
  }
};

const processValue = (value, idx) => {
  if (value !== "#") {
    if (valueType(idx) === "closed") {
      return value === "true";
    }
    return parseFloat(value);
  }
  return null;
};
// dailyValue: 89.4995_310_#_#_#_#_#
const processDailyValue = dailyValue => {
  const [rate, availability, closed, minStay, maxStay, minNotice, maxNotice] = dailyValue
    .split("_")
    .map((value, idx) => processValue(value, idx));
  return {
    [constants.ARI_VALUE_TYPE.RATE]: rate,
    [constants.ARI_VALUE_TYPE.AVAILABILITY]: availability,
    [constants.ARI_VALUE_TYPE.LOCK]: closed,
    [constants.ARI_VALUE_TYPE.MIN_STAY]: minStay,
    [constants.ARI_VALUE_TYPE.MAX_STAY]: maxStay,
    [constants.ARI_VALUE_TYPE.MIN_NOTICE]: minNotice,
    [constants.ARI_VALUE_TYPE.MAX_NOTICE]: maxNotice,
  };
};

// monthData : #_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#,#_0_#_#_#_#_#
const processMonth = ({ startMoment, monthData }) => {
  const dailyValues = monthData.split(",");
  const startDayIndex = startMoment.date() - 1; // This is the first day of the month we want info from
  const relevantDailyValues = dailyValues.slice(startDayIndex); // we ignore all dailyValues BEFORE the start Date
  return relevantDailyValues.map((dailyValue, idx) => ({
    date: moment(startMoment).add(idx, "days").toDate(),
    ...processDailyValue(dailyValue),
  }));
};

export const convertRawARIDataToStandardFormat = ({ rawData, startDate }) => {
  const result = [];
  const startMoment = moment(startDate);
  rawData.forEach(yearData => {
    const baseKey = Object.keys(yearData)[0];
    const monthlyData = yearData[baseKey];
    Object.keys(monthlyData).forEach(monthDataKey => {
      const monthData = monthlyData[monthDataKey];
      result.push(...processMonth({ startMoment, monthData }));
      startMoment.add(1, "month").startOf("month");
    });
  });
  return result;
};

export const convertStandardFormatToCalendarFormat = standardFormatARI => {
  const prices = standardFormatARI.reduce((accumulator, dailyValue) => {
    if (
      dailyValue[constants.ARI_VALUE_TYPE.AVAILABILITY] > 0 &&
      dailyValue[constants.ARI_VALUE_TYPE.LOCK] !== true
    ) {
      accumulator[moment(dailyValue.date).format("YYYY-MM-DD")] =
        dailyValue[constants.ARI_VALUE_TYPE.RATE];
    }
    return accumulator;
  }, {});

  return prices;
};

export const convertRawARIDataToToCalendarFormat = ({ rawData, startDate }) =>
  convertStandardFormatToCalendarFormat(convertRawARIDataToStandardFormat({ rawData, startDate }));
